<template>
  <div class="payment-wrap">
    <div class="c-page-pay">
      <Dialog title="家长代付" v-if="familyModal" @close="familyModal = false">
        <div class="modal-wechat">
          <p class="color-17181A fs-16 lh-24 sybold">
            复制并通过微信分享给你的父母<br />
            <span class="color-377ECF fs-16 lh-24 sybold">{{ guestPayLink }}</span>
          </p>
        </div>
        <div class="copy-wrap mt-40 J-click-copy" @click="handleClickCopy" :data-clipboard-text="guestPayLink">
          <Button skin="red">复制</Button>
        </div>
      </Dialog>
      <Dialog title="微信支付" v-if="weChatModal" @close="closeWeChatModal">
        <div class="modal-wechat">
          <Qr className="img-qr" :text="qr" :size="130" />
          <div class="pay-message">
            <p class="color-17181A fs-16 lh-24 sybold">如何支付</p>
            <p class="pt-10 color-494A4D fs-14 lh-21 synormal pc-only">进入微信“扫一扫”扫描二维码后支付</p>
            <p class="pt-10 color-494A4D fs-14 lh-21 synormal m-only">请长按保存左侧二维码后，进入微信“扫一扫”，并从相册选取次二维码图片后支付。</p>
          </div>
        </div>
      </Dialog>
      <Dialog title="支付" v-if="aliModal" @close="closeAliModal">
        <div class="modal-ali">
          <Button className="item" skin="black" @click="closeAliModal">遇到问题 重新付款</Button>
          <Button className="item" skin="red" @click="handleClickSuccess">已完成支付</Button>
        </div>
      </Dialog>
      <div class="page-content">
        <h1 class="h1 color-black">支付费用</h1>
        <div class="img-wrap">
          <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2021/sbp/image3.jpg" alt="" />
        </div>
        <p class="text1 color-gray-1 mt-30">
          祝贺你，通过个人努力和严格筛选，被录取成为2022哈佛商学院案例青年财经分析师科研计划（Student Business Pioneer powered by Harvard Business
          Publishing）的正式学员！
        </p>
        <p class="text1 color-gray-1 mt-10">
          哈佛商学院案例青年财经分析师科研计划（SBP）收到了几百份优秀学生的申请材料，并采取了哈佛校园有选拔性的学术和实习机会通用的comping挑战流程，不仅用一次面试选拔，而是在整个峰会活动的各个板块中综合考量你的学术成绩、案例群面表现和授课人推荐，选拔出了一小群综合竞争力突出的同学入选。你在Comping流程中所展现出的沟通能力、结构化思维、中英文表达能力、协作能力、和商业敏感度，令案例面试官印象深刻，使你从上千名峰会参与者中脱颖而出。我们很高兴能够通过申请过程认识这样一个你，并且非常期待在这个金秋在线下的商学院课堂见到你。
        </p>
        <p class="text1 color-gray-1 bold mt-20">接下来将发生什么？</p>
        <p class="text1 color-gray-1 mt-10">
          2022年秋季的SBP项目和疫情以来的过去两年一样，将采用Hybrid形式开展，即三周线上学术课程和研究+4天线下高强度学术课程和挑战。整体项目跨度为9月17日-10月16日。线上三周期间，将集中在周末时间、周中晚上时间进行线上案例研讨（中文、英文皆有）；线下活动部分将在哈佛在中国的官方代表中心——哈佛中心（上海）举行。线下日期（暂定）：10月2、3、4、5日。
        </p>
        <p class="text1 color-gray-2 mt-10">
          被SBP录取的同学将成为在哈佛中心（上海）正式完成哈佛商学院案例研究学术项目年龄最小的学生，在九月下旬在这里连续几天与大洋彼岸哈佛学者video
          conference、与现场一系列国内外名校学者面对面高强度学术交流，深入了解商学院的全真课程，并深入案例相关行业龙头企业中实地参访（根据当地疫情情况），和企业话事人近距离交流、和商业领域教授专家平等探讨，并将商学院教学方法带回学校，成为同学中的引领者。
        </p>
        <p class="text1 color-gray-2 mt-10">
          由于疫情相关要求，多地学校开学后对出省市返回有不同的政策，SBP项目组届时将会针对不能出省市的同学，探索不同形式的参与方式，包括线上线下的hybrid融合模式等，组委会将与确认出席的同学及所在学校保持密切沟通，关注疫情政策更新并提供帮助你顺利参与的方式。
        </p>
        <div class="img-wrap">
          <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2021/sbp/image6.png" alt="" />
        </div>
        <p class="text1 color-gray-1 bold mt-20">成为Student Business Pioneer，你将获得：</p>
        <ul class="ul text1 color-gray-1 mt-10">
          <li>基于哈佛商学院案例的全英文财经商业分析科研成果和论文</li>
          <li>哈佛商学院案例分析SBP项目青年财经分析师证书</li>
          <li>成果最杰出课题组成员获得组委会联合行业导师出具的推荐信（5-8%）</li>
          <li>突出课题在哈佛商学院出版中国K12领域官方授权平台刊登发表</li>
          <li>跨科技、消费、文化、艺术多领域的真实行业案例涉猎</li>
          <li>与海内外知名企业一线决策者直接对话机会</li>
        </ul>
        <p class="text1 color-gray-1 bold mt-20">下一步需要做什么？</p>
        <p class="text1 color-gray-1 mt-10">
          有任何关于SBP和你的席位的问题，欢迎致电400-180-5580转2，也可以写邮件至sbp@hsylc.cn，由组委会老师解答。
        </p>
        <p class="text1 color-gray-1 mt-10">请支付项目费用，在此之后，你的SBP席位将正式确认，开始课程前阅读材料准备等工作。</p>
        <p class="text1 color-gray-1 mt-10">
          说明：SBP参照哈佛商学院案例研讨课堂配置仅有90个学生席位，还有许多的同学在等候名单上。如果过了截止日期还未确认或支付，经沟通提醒后将视作放弃席位，席位将顺延给等候名单上下一位同学。
        </p>
        <p class="text1 color-gray-1 bold mt-20">支付项目费用</p>
        <p class="text1 color-gray-1 mt-10">
          祝贺你已经获得哈佛商学院案例青年财经分析师科研计划（Student Business Pioneer powered by Harvard Business
          Publishing）学生资格，请缴纳SBP项目费用，以正式锁定SBP的学生席位。
        </p>
        <p class="text1 color-gray-1 mt-10">
          2022年SBP费用与疫情以来两年SBP及疫情前历年哈佛实地交换生HWeek的项目部分费用保持一致，全部项目费用为3,500美元（23,730
          元人民币），汇率=6.7813（中国银行2022年8月3日美元兑人民币汇率中间价）。像哈佛商学院一样，SBP项目提供部分助学金，用于资助经济有较大困难的同学，具体申请方法请见下方。
        </p>
        <p class="text1 color-gray-1 mt-10">
          项目费用包含哈佛商学院全部原版学术资料独家版权支付、独家授权项目注册、跨三周全程与哈佛商学院、哈佛各其他学院等名校学者的高强度学术研讨和交流、哈佛原版学术阅读材料、论文文献、哈佛商学院商业模拟（Simulation）技术系统、独家授权技术平台和账号、国内外知名大学师资和独家活动、哈佛商学院出版官方授权项目证书、哈佛中心线下活动期间一日三餐和活动材料等。项目费用不包含：上海住宿费用、往返会场和外地往返上海的交通费。以上安排与往年活动保持不变。
        </p>
        <p class="text1 color-gray-1 mt-10">
          SBP项目和哈佛商学院一样提供部分助学金支持，用于支持经济有较大困难的学生可以顺利出席活动。如果你在峰会里已经是助学金获得者，请直接回复你的录取信邮件，或发送邮件至sbp@hsylc.cn表达你希望获得资助的具体情况，不需要重新提交一次证明文件。如果你不是峰会的助学金获得者，但是有经济困难需要申请SBP项目的助学金，现在则需要重新提交一次全套的经济证明材料。请在项目费用截止日期前完成助学金完整申请表的填写，
          <a href="https://jinshuju.net/f/lXKXj2" target="_blank" class="link color-red-default bold">
            表格点击这里打开
          </a>
          。其中需要你上传家庭经济证明（例如工资证明等），以及学校盖章证明，需要学校盖章的文件
          <a href="https://files.hsylc.cn/cloud-uploads/user-2/SBP_2022/2022_sbp_application.pdf" class="color-red-default bold link" target="_blank">
            点击这里下载
          </a>
          。在收到你的完整助学金申请后，我们会在1-2天内完成助学金审核，发给你审核结果，然后你可以进行下一步的流程。
        </p>
        <!-- 必选 -->
        <div class="checkBox-line font16 syNormal marginTop30 " @click="handleConfirm">
          <div class="tick-wrap" :class="isConfirm ? 'active' : ''">
            <Tick class="icon" :color="tickColor" />
          </div>
          <div class="text">
            我已阅读
            <span class="color-A11A22 sybold" data-pageName="pay-admission-notices" @click="windowOpen('/sbp/announcement')">
              哈佛商学院案例研究青年财经分析师科研计划（SBP）项目付款及取消须知
            </span>
            的全文并完全同意。
          </div>
        </div>

        <p class="sybold mt-30 color-17181A fs-16 lh-24">选择支付方式</p>
        <PayChannel class="mt-10" :value="channel" :family="true" :channels="channels" @input="handleChannelInput" />
        <!-- <div class="color-7C7D80 font16 syNormal marginTop10">成功被峰会录取的同学，之前交的90元申请费会自动抵扣费用。</div> -->
        <div class="color-E61717 font16 syNormal marginTop10" v-if="isOver">
          <strong>你未在组委会指定日期内完成费用支付，默认为放弃峰会学生资格。如有问题请联系组委会。</strong>
        </div>
        <div class="marginBottom100"></div>

        <!-- <p class="pay-tip synormal mt-10 color-7C7D80 fs-12 lh-16">
          线下报名码仅在HSYLC校友推荐、学校推荐等活动中发放，详情请关注微信公众号“哈佛HSYLC峰会”，或询问邮箱apply@hsylc.cn。如果你正在争取推荐名额，我们建议你先提交申请费，这将使你的申请材料率先进入组委会的审核流程。在拿到校友或学校的推荐名额后，可写邮件至apply@hsylc.cn申请退费。
        </p> -->
      </div>
      <div class="pay-footer">
        <div class="footer-content">
          <p class="pay-info color-7C7D80">
            项目费用：<span class="sybold color-A11A22 bold">¥</span><span class="sybold price color-A11A22">{{ payPrice }}</span>
          </p>
          <Button className="btn-pay" skin="red" :customStyle="{ height: '100%' }" v-if="status === STATUS.PAY && !isOver && feeData" @click="handleClickPay">
            付款
          </Button>
          <Button className="btn-pay" disabled :customStyle="{ height: '100%' }" v-else-if="isOver || !feeData">付款</Button>
          <Button className="btn-pay" disabled :customStyle="{ height: '100%' }" v-else-if="status === STATUS.PAID">已付款</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
import Clipboard from 'clipboard';
import { Button } from 'components/form';
import Tick from 'components/icons/Tick';
import PayChannel from 'components/PayChannel';
import CHANNEL from 'components/PayChannel/channel';
import { Api, Codes } from 'api';
import Payment from 'utils/pay';
import Moment from 'moment';
import { Message } from 'element-ui';
import STU_TYPE from 'utils/stuType';
import { getRequest } from 'utils/string';
import moment from 'moment';
//支付状态 1 未支付 2 已支付 3 退款
const STATUS = {
  PAY: 1,
  PAID: 2,
  REFUND: 3
};
export default {
  name: 'Pay',
  components: {
    Dialog: () => import('components/Dialog'),
    Qr: () => import('vue-qr'),
    Button,
    PayChannel,
    Tick
  },
  computed: {
    CHANNEL() {
      return CHANNEL;
    },
    stuType() {
      let ret = 0;
      if (this.feeData) {
        ret = this.feeData.active_type;
      }
      return ret;
    },
    channels() {
      let ret = ['WX', 'AL'];
      // if (this.feeData) {
      //   ret = this.feeData.channels;
      // }

      return ret;
    },
    ebDate() {
      let ret = '';
      let feeData = this.feeData;
      if (feeData && feeData.deadlines && !!feeData.deadlines.eb) {
        let eb = feeData.deadlines.eb;
        ret = Moment(eb).format('YYYY年M月D日');
      }
      return ret;
    },
    rdDate() {
      let ret = '';
      let feeData = this.feeData;
      if (feeData && feeData.deadlines && !!feeData.deadlines.rd) {
        let rd = feeData.deadlines.rd;
        ret = Moment(rd).format('YYYY年M月D日');
      }
      return ret;
    },
    price() {
      let ret = 0;
      if (this.order) {
        ret = this.order.fee;
      }
      return ret;
    },
    STATUS() {
      return STATUS;
    },
    status() {
      return this.order ? this.order.status : STATUS.PAY;
    },
    payPrice() {
      return this.channel === CHANNEL.SDL ? 0 : this.price;
    },
    STU_TYPE() {
      return STU_TYPE;
    },
    // 勾选 颜色
    tickColor() {
      let color = this.isConfirm ? '#fff' : '#E6E6E6';
      return color;
    },
    guestPay() {
      let ret = false;
      if (this.guestPayToken) {
        ret = true;
      }
      return ret;
    },
    guestPayLink() {
      let origin = window.location.origin;
      let ret = origin + '/pay/sbp-parent/';
      if (this.guestPay) {
        ret += this.guestPayToken;
      }
      return ret;
    }
  },
  data: () => ({
    time7: '', // 用户 createAt + 7 时间
    signCodeModal: false,
    signCode: '',
    weChatModal: false,
    aliModal: false,
    channel: '',
    feeData: null, // 订单 信息
    payment: null,
    order: null,
    qr: '',
    isCodeLegal: false,
    Time: null,
    isOver: false, //  是否结束
    paid: false,
    init: false,
    familyModal: false,
    guestPayToken: null,
    isConfirm: false // 是否同意退费政策
  }),
  mounted: async function() {
    this.statusData = await this.$_getStuStatusData();
    await this.checkPermission();
    await this.initData();
  },
  methods: {
    async checkOffer() {
      let res = await this.$_isPermitted(
        [
          {
            key: 'sbp_offer'
          }
        ],
        this.statusData
      );
      if (!res) {
        this.$message.error('仅限SBP录取学生访问');
        this.$location('/');
      }
    },
    async checkPermission() {
      await this.checkOffer();
    },
    async initData() {
      this.$loading.show();
      let feeData = await Api.post.postStudentSbpFee();
      if (feeData.status === Codes.SUCCESS) {
        this.feeData = feeData.data;
        if (this.feeData.order) {
          this.order = this.feeData.order;
        }
        if (this.feeData.guest_pay_token && this.feeData.guest_pay_token !== '') {
          this.guestPayToken = this.feeData.guest_pay_token;
        }
        let query = getRequest();
        if (this.order?.status === STATUS.PAID) {
          // window.location.href = '/sbp/manage';
          window.location.href = '/sbp/course-duration';
        } else if (!query.hasRefresh && this.order?.status === STATUS.PAID) {
          setTimeout(() => {
            window.location.href = '/sbp/pay?hasRefresh=true';
          }, 1000);
        }
        if (query.wxmp && !this.paid) {
          this.channel = CHANNEL.WX;
          await this.handleStartPay();
        }
      } else if (feeData.msg) {
        Message({
          type: 'error',
          message: feeData.msg
        });
        if (!this.isDeveloper) {
          this.$location('/');
        }
      }
      this.$loading.hide();
    },
    handleClickCopy: function() {
      let clipboard = new Clipboard('.J-click-copy');
      clipboard.on('success', e => {
        Message({
          type: 'success',
          message: '复制成功'
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        Message({
          type: 'error',
          message: '该浏览器不支持自动复制'
        });
        // 不支持复制
        console.log('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    },
    windowOpen(href) {
      this.$windowOpen(href);
    },
    // 跳转页面
    handleGoToPage(e) {
      let pageName = e.target.dataset.pagename;

      let routeData = this.$router.resolve({
        name: pageName
      });
      this.$windowOpen(routeData.href);
    },
    // 勾选 必填
    handleConfirm() {
      this.isConfirm = !this.isConfirm;
    },
    handleChannelInput: function(channel) {
      let that = this;
      if (channel === CHANNEL.FAMILY) {
        this.familyModal = true;
      } else if (channel !== CHANNEL.SDL) {
        this.channel = channel;
      } else {
        this.channel = '';
        this.signCode = '';
        this.signCodeModal = true;
      }
    },

    handleStartPay: async function() {
      let that = this;
      that.$loading.show();
      that.payment = new Payment({
        orderId: that.order.id,
        channel: that.channel || CHANNEL.SDL,
        code: that.signCode,
        aliWapCb: function() {
          that.aliModal = true;
          that.$loading.hide();
        },
        wxQrCb: function(qr) {
          that.qr = qr;
          that.weChatModal = true;
          that.$loading.hide();
        },
        errCb: function(msg) {
          if (msg && !!msg) {
            Message({
              type: 'error',
              message: msg
            });
          }
          that.$loading.hide();
        },
        successCb: function() {
          that.success();
        }
      });
    },
    handleClickSuccess: async function() {
      await this.initData();
      if (this.order?.status === STATUS.PAID) {
        this.$router.push({
          name: 'sbp-manage'
        });
      } else {
        Message({
          type: 'error',
          message: '支付尚未成功！'
        });
      }
      // window.location.href = '/pay/apply';
    },
    success: function() {
      this.$loading.hide();
      Message({
        type: 'success',
        message: '支付成功！'
      });

      this.$router.push({
        name: 'sbp-manage'
      });
    },
    closeAliModal: function() {
      this.aliModal = false;
      if (this.payment) {
        this.payment.cleanListen();
      }
    },
    closeWeChatModal: function() {
      this.weChatModal = false;
      if (this.payment) {
        this.payment.cleanListen();
      }
    },
    // 付款 按钮 点击
    handleClickPay: async function() {
      let that = this;
      if (!this.isConfirm) {
        this.$message.error('请确认已了解退费政策');
        return;
      }
      if (that.channel && that.channel !== '') {
        if (that.channel !== CHANNEL.SDL) {
          await that.handleStartPay();
        } else if (that.payment) {
          that.payment.CodePay();
        }
      } else {
        Message({
          type: 'error',
          message: '请选择支付渠道'
        });
      }
    }
  }
};
</script>
